import searchProperty from '../modules/search-property/index.vue'

const unsupported = () => import('../modules/unsupported/index.vue');
const contacts = () => import('../modules/contacts/index.vue');
const payment = () => import('../modules/payment/index.vue');
const analysis = () => import('../modules/analysis/index.vue');
const thanks = () => import('../modules/thanks/index.vue');
const message = () => import('../modules/message/index.vue');

export default [
  {
    path: '/',
    name: 'searchProperty',
    component: searchProperty
  },
  {
    path: '/unsupported-property',
    name: 'unsupported',
    component: unsupported
  },
  {
    path: '/contacts',
    name: 'contacts',
    component: contacts
  },
  {
    path: '/payment',
    name: 'payment',
    component: payment
  },
  {
    path: '/analysis',
    name: 'analysis',
    component: analysis
  },
  {
    path: '/thanks',
    name: 'thanks',
    component: thanks
  },
  {
    path: '/message',
    name: 'message',
    component: message
  },
  {
    path: '*',
    redirect: '/'
  },
];